import { createContext, ReactNode, useEffect } from 'react';
import { useImmerReducer } from 'use-immer';
import { isEmpty } from 'lodash';
import { useRouter } from 'next/router';

import { actions, authReducer, IAuthState, INITIAL_AUTH_STATE } from 'auth/state/authReducer';
import { IUser } from 'auth/types/User';
import { logOutUser } from 'auth/services/logOutUser';

interface IAuthProviderProps {
  children: ReactNode;
  user: IUser;
}

export const AuthStateContext = createContext<IAuthState>(INITIAL_AUTH_STATE);
export const AuthDispatchContext = createContext(null);

export const AuthProvider = ({ children, user }: IAuthProviderProps) => {
  const initialState: IAuthState = isEmpty(user)
    ? INITIAL_AUTH_STATE
    : { isAuthenticated: true, user };
  const [state, dispatch] = useImmerReducer(authReducer, initialState);
  const { asPath } = useRouter();

  const logoutGuestUser = async () => {
    await logOutUser();

    dispatch({ type: actions.logOut });
  };

  useEffect(() => {
    if (asPath.startsWith('/checkout') === false && user?.isGuest) {
      void logoutGuestUser();
    }
  }, [asPath]);

  return (
    <AuthDispatchContext.Provider value={dispatch}>
      <AuthStateContext.Provider value={state}>{children}</AuthStateContext.Provider>
    </AuthDispatchContext.Provider>
  );
};
